import StorageHelper from 'Src/helpers/storage/storage';
import { SuperAdminSession } from 'Src/models/superadmin/session';

const SUPER_ADMIN_SESSION_KEY = 'superAdminSession';

export function getSuperAdminSession(): SuperAdminSession | undefined {
  return StorageHelper.SessionStorage.get(SUPER_ADMIN_SESSION_KEY);
}

export function getSuperAdminSessionKey(): string | undefined {
  const session = getSuperAdminSession();
  return session ? session.key : undefined;
}

export function setSuperAdminSession(session: SuperAdminSession): void {
  StorageHelper.SessionStorage.set(SUPER_ADMIN_SESSION_KEY, session);
}

export function clearSuperAdminSession(): void {
  StorageHelper.SessionStorage.remove(SUPER_ADMIN_SESSION_KEY);
}

export function isSuperAdminLoggedIn(): boolean {
  return typeof getSuperAdminSessionKey() !== 'undefined';
}
